import { Box } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { ButtonWrapper, RanaButton } from "@nens/ranalib";

import { BackButton } from "@/components/back-button";
import { ModelSchematisationDetails } from "@/lib/schematisation-details";
import { SchematisationWithId } from "@/queries/query-hcc-schematisation";

import { AddToProjectButtonOverride } from "../../types/add-to-project-button-override";
import { SchematisationProjectImportButton } from "../project-import/schematisation-project-import";

interface CatalogueSchematisationDetailsProps {
  schematisation: SchematisationWithId;
  backToSchematisations: () => void;
  showRevisionHistory: () => void;
  selectedRevisionId: number | undefined;
  overwriteAddToProjectButton?: AddToProjectButtonOverride;
}

export function CatalogueSchematisationDetails({
  schematisation,
  selectedRevisionId,
  overwriteAddToProjectButton,
  showRevisionHistory,
  backToSchematisations,
}: CatalogueSchematisationDetailsProps) {
  const addToProjectButton = overwriteAddToProjectButton ? (
    overwriteAddToProjectButton({
      schematisation,
      revisionId: selectedRevisionId,
    })
  ) : (
    <SchematisationProjectImportButton
      from="catalogue"
      revisionId={selectedRevisionId}
      schematisation={schematisation}
    />
  );

  const headerActions = (
    <ButtonWrapper flexWrap="wrap">
      <RanaButton variant="secondary" onClick={showRevisionHistory}>
        <FormattedMessage id="button.revision_history" defaultMessage="Revision history" />
      </RanaButton>
      {addToProjectButton}
    </ButtonWrapper>
  );

  return (
    <Box>
      <BackButton back={backToSchematisations}>
        <FormattedMessage
          id="button.back_to_schematisations"
          defaultMessage="Back to model schematisations"
        />
      </BackButton>
      <ModelSchematisationDetails
        headerActions={headerActions}
        schematisationId={schematisation.id}
        mode="catalogue"
        selectedRevisionId={selectedRevisionId}
      />
    </Box>
  );
}
